import { http } from "./client";

export const authApi = {
  // POST /auth/logout → 204; the token stops working right away
  logout: () => http.post("/auth/logout").then(() => undefined),
};
